<template>
    <section class="billing-panel">
        <slot />
    </section>
</template>

<script>
export default {
    name: 'BillingPanel',
};
</script>

<style scoped>
.billing-panel {
    background: var(--billing-card-bg);
    border: 1px solid var(--billing-border);
    border-radius: 8px;
    box-shadow: 0 18px 40px rgba(4, 14, 30, 0.12);
}
</style>
